import script from "./project-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./project-details-modal.vue?vue&type=script&setup=true&lang=js"

import "./project-details-modal.vue?vue&type=style&index=0&id=38594243&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38594243"]])

export default __exports__